import { ROUTE } from "../../routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { DigioKycStatus } from "../../configs/constants";
import { nextStepCredStepper } from "../../configs/utils";
import { ACTION } from "./types";
let pollInterval;
let responseFromDigio;
let isPopupShown = false;
let hasClicked = false;
export const GoToNumber = async (action, _datastore, { navigate, goBack }) => {
    // await goBack();
    await AsyncStorage.setItem('first_time', 'true');
    navigate(ROUTE.SPLASH_SCREEN);
};
export const closeModal = async (action, _datastore, { goBack, showPopup }) => {
    goBack();
    await showPopup({
        type: 'FAILED',
        title: 'Agreement signing canceled',
        subTitle: 'Agreement signing is required for the completion of your loan application',
        ctaLabel: 'Try again',
        primary: true,
        ctaAction: {
            routeId: ROUTE.DIGIO_DOC_MODAL,
            type: ACTION.FAILED_VERIFICATION,
            payload: {},
        },
    });
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    await hidePopup();
};
export const successVerification = async (action, _datastore, { goBack, navigateWithClear }) => {
    isPopupShown = true;
    hasClicked = true;
    const routeObj = await nextStepCredStepper();
    navigateWithClear(routeObj.routeId, routeObj.params);
};
export const digioCallback = async (action, datastore, { network, showPopup, hidePopup, goBack, navigateWithClear }) => {
    responseFromDigio = action.payload;
    const type = action.payload.type;
    const error = action.payload.error;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : userContextResponse.data.linkedApplications[0].applicationId;
    await network.get(`${api.digioDocsCheckRequestStatusOnCallBack}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(async (response) => {
        if (response.status === 200 &&
            response.data.stepResponseObject ===
                DigioKycStatus.SIGNED || type === 'success') {
            await navigateWithClear(ROUTE.DIGIO_AGREEMENT_SIGN, {
                loading: true
            });
            if (!hasClicked) {
                setTimeout(async () => {
                    const routeObj = await nextStepCredStepper();
                    navigateWithClear(routeObj.routeId, routeObj?.params);
                    isPopupShown = true;
                }, 3000);
            }
            if (!isPopupShown) {
                showPopup({
                    type: 'SUCCESS',
                    title: 'Agreement signed successfully',
                    subTitle: 'You will be redirected to next step in few seconds',
                    ctaLabel: 'Continue',
                    ctaAction: {
                        routeId: ROUTE.DIGIO_DOC_MODAL,
                        type: ACTION.SUCCESS_VERIFICATION,
                        payload: {},
                    },
                    shouldAutoNavigate: true
                });
            }
        }
        else if (error === 'user_cancelled') {
            await goBack();
            showPopup({
                title: 'KYC Verification cancelled',
                ctaLabel: 'Try again',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.DIGIO_MODAL,
                    type: ACTION.FAILED_VERIFICATION,
                    payload: {},
                },
                type: "FAILED",
                subTitle: "Please try again in sometime",
            });
        }
        else {
            console.log("Digio process not started");
        }
    });
};
